import { memo, forwardRef } from 'react';
import * as React from 'react';

import {
    RadioButtonInput,
    RadioButtonLabel,
    RadioButtonActiveColors,
    RadioButtonActiveBackgroundColors
} from './RadioButton.styles';

export type RadioButtonOnClick = (
    event: React.FormEvent<HTMLInputElement>
) => void;

export interface RadioButtonProps extends Partial<HTMLInputElement> {
    label: string;
    radioGroupName?: string;
    activeTextColor?: RadioButtonActiveColors;
    activeBackgroundColor?: RadioButtonActiveBackgroundColors;
    errorMessage?: string;
    ref?: React.Ref<HTMLInputElement>;
    onClick?: RadioButtonOnClick;
}

export const RadioButton = memo(
    forwardRef<HTMLInputElement, RadioButtonProps>(
        (
            {
                id,
                radioGroupName,
                label,
                activeTextColor = 'grey-slate',
                value,
                errorMessage,
                activeBackgroundColor = 'function-success',
                onClick
            },
            ref
        ) => (
            <>
                <RadioButtonInput
                    type="radio"
                    id={`${radioGroupName}-${id}`}
                    data-testid={`input-${radioGroupName}-${id}`}
                    name={radioGroupName}
                    value={value}
                    ref={ref}
                    onClick={onClick}
                    activeTextColor={activeTextColor}
                    activeBackgroundColor={activeBackgroundColor}
                />
                <RadioButtonLabel
                    data-testid={`label-${radioGroupName}-${id}`}
                    /*
                        Although we are wrapping the input, the htmlFor is maintained as some assistive technologies do not implicity apply the for attribute.
                        https://www.w3.org/TR/2008/WD-WCAG20-TECHS-20080430/H44.html
                    */
                    htmlFor={`${radioGroupName}-${id}`}
                    errorMessage={errorMessage}
                >
                    {label}
                </RadioButtonLabel>
            </>
        )
    )
);
